<template>
    <el-row span="24" v-loading="getScreenSize < 2 && !delayedLoading[10]" element-loading-text="Loading...">
        <el-col :span="24">
            <el-form ref="form" label-position="top">
                <el-row :gutter="25"> 
                    <el-col v-if="getScreenSize > 1 || delayedLoading[0]" :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/interface/Realtime display')">
                            <el-time-picker v-model="getSettingsInterface.rtvaluesPicker"
                                :picker-options="{
                                    selectableRange: '00:00:00 - 01:00:00'
                                }">
                            </el-time-picker>
                            <el-input v-show="false" v-model="getSettingsInterface.rtvalues"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="getScreenSize > 1 || delayedLoading[1]" :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/interface/Language')">
                            <el-select v-model="getSettingsInterface.language" :placeholder="$l('common/select')">
                                <el-option :label="$l('settings/interface/english')" value="en"></el-option>
                                 <el-option :label="$l('settings/interface/austria')" value="at"></el-option>
                                <el-option :label="$l('settings/interface/german')" value="de"></el-option>
                                <el-option :label="$l('settings/interface/french')" value="fr"></el-option>
                                <el-option :label="$l('settings/interface/slovensko')" value="sl"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col v-if="getScreenSize > 1 || delayedLoading[2]" :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/interface/Lt')">
                            <el-select :disabled="getSettingsAddons['noise']==0" v-model="getSettingsInterface.RangNOtype" :placeholder="$l('common/select')">
                                <el-option :label="$l('settings/interface/Manual')" value="0"></el-option>
                                <el-option :label="$l('settings/interface/Dynamic')" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col v-if="getScreenSize > 1 || delayedLoading[3]" :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/interface/Manual')">
                            <el-row>
                                <el-col :span="11">
                                    <el-input-number :disabled="getSettingsInterface.RangNOtype==1 || getSettingsAddons['noise']==0" v-model="getSettingsInterface.RangNO[0]" style="width: 100%;"></el-input-number>
                                </el-col>
                                <el-col class="line" :span="2">-</el-col>
                                <el-col :span="11">
                                    <el-input-number :disabled="getSettingsInterface.RangNOtype==1 || getSettingsAddons['noise']==0" v-model="getSettingsInterface.RangNO[1]" style="width: 100%;"></el-input-number>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>

                    <el-col v-if="getScreenSize > 1 || delayedLoading[4]" :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/interface/Spectrum')" :placeholder="$l('common/select')">
                            <el-select :disabled="getSettingsAddons['noise']==0" v-model="getSettingsInterface.RangSPtype">
                                <el-option :label="$l('settings/interface/Manual')" value="0"></el-option>
                                <el-option :label="$l('settings/interface/Dynamic')" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col v-if="getScreenSize > 1 || delayedLoading[5]" :lg="12">
                        <el-row>
                            <el-form-item class="el-form-item-full" :label="$l('settings/interface/Manual')">
                                <el-col :span="11">
                                    <el-input-number :disabled="getSettingsInterface.RangSPtype==1 || getSettingsAddons['noise']==0"  v-model="getSettingsInterface.RangSP[0]" style="width: 100%;"></el-input-number>
                                </el-col>
                                <el-col class="line" :span="2">-</el-col>
                                <el-col :span="11">
                                    <el-input-number :disabled="getSettingsInterface.RangSPtype==1 || getSettingsAddons['noise']==0"  v-model="getSettingsInterface.RangSP[1]" style="width: 100%;"></el-input-number>
                                </el-col>
                            </el-form-item>
                        </el-row>
                    </el-col>

                    <el-col v-if="getScreenSize > 1 || delayedLoading[6]" :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/interface/Weather')">
                            <el-select :disabled="getSettingsAddons['weather']==0" v-model="getSettingsInterface.RangWEtype" :placeholder="$l('common/select')">
                                <el-option :label="$l('settings/interface/Manual')" value="0"></el-option>
                                <el-option :label="$l('settings/interface/Dynamic')" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="getScreenSize > 1 || delayedLoading[7]" :lg="12">
                        <el-row>
                            <el-form-item class="el-form-item-full"  :label="$l('settings/interface/Manual')">
                                <el-col :span="11">
                                    <el-input-number :disabled="getSettingsInterface.RangWEtype==1 || getSettingsAddons['weather']==0"  v-model="getSettingsInterface.RangWE[0]" style="width: 100%;"></el-input-number>
                                </el-col>
                                <el-col class="line" :span="2">-</el-col>
                                <el-col :span="11">
                                    <el-input-number :disabled="getSettingsInterface.RangWEtype==1 || getSettingsAddons['weather']==0"  v-model="getSettingsInterface.RangWE[1]" style="width: 100%;"></el-input-number>
                                </el-col>
                            </el-form-item>
                        </el-row>
                    </el-col>

                     <el-col v-if="getScreenSize > 1 || delayedLoading[8]" :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/interface/Adio')">
                            <el-select :disabled="getSettingsAddons['adio']==0" v-model="getSettingsInterface.RangADIOtype" :placeholder="$l('common/select')">
                                <el-option :label="$l('settings/interface/Manual')" value="0"></el-option>
                                <el-option :label="$l('settings/interface/Dynamic')" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="getScreenSize > 1 || delayedLoading[9]" :lg="12">
                        <el-row>
                            <el-form-item class="el-form-item-full"  :label="$l('settings/interface/Manual')">
                                <el-col :span="11">
                                    <el-input-number :disabled="getSettingsInterface.RangADIOtype==1 || getSettingsAddons['adio']==0"  v-model="getSettingsInterface.RangADIO[0]" style="width: 100%;"></el-input-number>
                                </el-col>
                                <el-col class="line" :span="2">-</el-col>
                                <el-col :span="11">
                                    <el-input-number :disabled="getSettingsInterface.RangADIOtype==1 || getSettingsAddons['adio']==0"  v-model="getSettingsInterface.RangADIO[1]" style="width: 100%;"></el-input-number>
                                </el-col>
                            </el-form-item>
                        </el-row>
                    </el-col>

                    <el-col v-if="getScreenSize > 1 || delayedLoading[10]" :lg="12">
                        <el-row>
                            <el-form-item class="el-form-item-full" :label="$l('settings/interface/noiseTriggerLevel')">
                                <el-switch v-model="getSettingsInterface.showNoiseTriggerLevel"></el-switch>
                            </el-form-item>
                        </el-row>
                    </el-col>
                </el-row>
            </el-form>
        </el-col>
    </el-row>
</template>

<style scoped>

.el-form-item{
    clear:both;
    float:left;
    font-size:10px;
}
</style>

<script>
import { mapGetters } from 'vuex'

export default {
    //How to gray out / disable inputs
    data() {
        return {
            delayedLoading:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0}
        }
    },
    computed:{
         ...mapGetters([
            'getSettingsInterface',
            'getSettingsAddons',
            'getScreenSize'
        ]),
    },
    methods: {
        onSubmit() {
            console.log('submit!');
        }, 
    },
    mounted: function(){
        setTimeout(()=>{
            var counter = 0;
            var delayedLoadingInterval = setInterval(()=>{
                this.delayedLoading[counter] = true;
                counter++;
                if(counter > 10) 
                    clearInterval(delayedLoadingInterval);
            },0);
        },500)
    }
}
</script>


// WEBPACK FOOTER //
// Interface.vue?da65d620